var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ModalBase from "../../components/modalbase.vue";
function createSvg(s) {
    const dp = new DOMParser();
    const svg = dp.parseFromString(s, "image/svg+xml").documentElement;
    return svg;
}
let TechnicalDrawingsDialogView = class TechnicalDrawingsDialogView extends Vue {
    constructor() {
        super(...arguments);
        this.currentIndex = 0;
    }
    close() { }
    updateIndex(index) {
        const s = this.$el.querySelector(".tech-draw-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.tech-draw-svg' does not match");
        }
        s.removeChild(this.currentSvg);
        this.currentIndex = index;
        this.currentSvg = createSvg(this.svgs[this.currentIndex]);
        s.appendChild(this.currentSvg);
    }
    decreaseCurrentIndex() { this.updateIndex(this.currentIndex - 1); }
    increaseCurrentIndex() { this.updateIndex(this.currentIndex + 1); }
    mounted() {
        this.currentSvg = createSvg(this.svgs[this.currentIndex]);
        const s = this.$el.querySelector(".tech-draw-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.tech-draw-svg' does not match");
        }
        s.appendChild(this.currentSvg);
    }
};
__decorate([
    Prop({ required: true })
], TechnicalDrawingsDialogView.prototype, "svgs", void 0);
__decorate([
    Inject()
], TechnicalDrawingsDialogView.prototype, "i18n", void 0);
__decorate([
    Emit()
], TechnicalDrawingsDialogView.prototype, "close", null);
TechnicalDrawingsDialogView = __decorate([
    Component({
        components: {
            "modal-base": ModalBase,
        },
        name: "TechnicalDrawingsDialogView",
    })
], TechnicalDrawingsDialogView);
export default TechnicalDrawingsDialogView;
